export default "__VITE_ASSET__55254df2__"